import React, { useMemo } from 'react'
import { useForm } from './form'
import { useHistory } from 'react-router-dom'

export const ButtonSubmit = ({ text }) => {
  const { getFormDirty, getFormErrors, getFormDisabled } = useForm()

  const dirty = getFormDirty()
  const errors = getFormErrors()
  const disabled = getFormDisabled()

  const hasDirty = useMemo(() => Object.keys(dirty).some(key => dirty[key]), [dirty])
  const hasErrors = useMemo(() => Object.keys(errors).some(key => errors[key]), [errors])

  return <input className="btn btn-primary text-capitalize" type="submit" value={text || 'save'} disabled={!hasDirty || hasErrors || disabled} />
}

const ButtonBack = ({ backURL }) => {
  const history = useHistory()

  const handleBack = e => {
    e.preventDefault()
    history.replace(backURL)
  }

  return backURL
    ? <button className="btn btn-secondary me-2" onClick={handleBack}>
        Back
      </button>
    : <React.Fragment />
}

const ButtonCancel = ({ onClick }) => {
  const handleClick = e => {
    e.preventDefault()
    onClick()
  }

  return onClick
    ? <button className="btn btn-secondary me-2" onClick={handleClick}>
        Cancel
      </button>
    : <React.Fragment />
}

export const FormSimpleSubmitCreate = ({ text, backURL, onCancel }) => {
  return (
    <React.Fragment>
      <ButtonCancel onClick={onCancel} />
      <ButtonBack backURL={backURL} />
      <ButtonSubmit text={text || 'create'} />
    </React.Fragment>
  )
}

export const FormSimpleSubmitEdit = ({ text, backURL, onCancel }) => {
  return (
    <React.Fragment>
      <ButtonCancel onClick={onCancel} />
      <ButtonBack backURL={backURL} />
      <ButtonSubmit text={text || 'update'} />
    </React.Fragment>
  )
}

export const FormSimpleSubmitSelfRegister = ({ text, backgroundColor, textColor }) => {
  const { getFormDirty, getFormErrors, getFormDisabled } = useForm()

  const dirty = getFormDirty()
  const errors = getFormErrors()
  const disabled = getFormDisabled()

  const hasDirty = useMemo(() => Object.keys(dirty).some(key => dirty[key]), [dirty])
  const hasErrors = useMemo(() => Object.keys(errors).some(key => errors[key]), [errors])

  return (
    <input
      style={{ backgroundColor: backgroundColor, color: textColor }}
      className={backgroundColor ? 'btn border text-capitalize' : 'btn btn-primary text-capitalize'}
      type="submit"
      value={text || 'submit'}
      disabled={!hasDirty || hasErrors || disabled}
    />
  )
}
